module.exports = __webpack_public_path__ + "static/articlegroup-916fde6dc2ec56ee348d36580fcce594.png";